/* eslint-disable @typescript-eslint/no-empty-function */
import { Flex } from '@chakra-ui/react'
import PropTypes from 'prop-types'

ListBox.propTypes = {
  title: PropTypes.any,
  list: PropTypes.array,
  textField: PropTypes.string,
  onClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  rest: PropTypes.any,
}

function ListBox({ title, list, textField, onClick, onContextMenu, ...rest }) {
  const toggleSelected = index => {
    list[index].selected = !list[index].selected
    onClick()
  }

  const toggleSetDefault = (e, index) => {
    e.preventDefault()
    list.forEach(element => {
      element.default = false
    })
    list[index].default = true
    onContextMenu(index)
  }

  const getClassName = item => {
    let classes = ''
    if (item.selected) classes += 'selected '
    if (item.default) classes += 'default '
    return classes
  }

  return (
    <Flex
      layerStyle="listBox"
      {...rest}>
      <Flex
        wordBreak="break-word"
        fontWeight="bold">
        {title}
      </Flex>
      <Flex className="list">
        {list &&
          list.map((item, index) => (
            <div
              key={index}
              className={getClassName(item)}
              onClick={
                onClick
                  ? () => {
                    toggleSelected(index)
                  }
                  : () => { }
              }
              onContextMenu={
                onContextMenu
                  ? e => {
                    toggleSetDefault(e, index)
                  }
                  : () => { }
              }>
              {item[textField]}
            </div>
          ))}
      </Flex>
    </Flex>
  )
}

export default ListBox
